var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"dialog-drag d-none d-md-block"},[_vm._v("mdi-cursor-move")])}
var staticRenderFns = []

export { render, staticRenderFns }